import { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { RegistrationContext } from '../../../context/registration';

import { setTermClauses } from '~/services/registration';

import { ProgressBar } from '../ProgressBar';
import {
  Container,
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Form,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';

import { fetchTermClauses } from '~/services/options';
import { fetchCampaignContext } from '~/services/registration';
import { Loading } from '../../../shared/components/Loading';
import { otherTypeCodes } from '~/shared/config';
import parse from 'html-react-parser';

interface ClauseOption {
  id: number;
  category: string;
  template: string;
  agree: boolean;
}

export const TermsOfService = ({}: any) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [saving, setSaving] = useState<boolean>(false);
  const [{ campaignRequest }, registrationDispatch] =
    useContext(RegistrationContext);
  const [clauseOptions, setClauseOptions] = useState<ClauseOption[]>([]);
  const [clauseIndex, setClauseIndex] = useState(0);
  const history = useHistory();

  const getCampaign = async () => {
    const resp = await fetchCampaignContext();
    console.log('resp: ', resp);

    registrationDispatch({
      type: 'set_registration',
      payload: resp,
    });
  };

  const getTermClauseOptions = async () => {
    const resp = await fetchTermClauses();
    console.log('resp: ', resp);
    const opts = resp.map((opt) => {
      return {
        id: opt.id,
        category: opt.category,
        template: opt.template,
        agree: false,
      };
    });
    setClauseOptions(opts);
    setLoading(false);
  };

  useEffect(() => {
    getTermClauseOptions();

    if (!campaignRequest) {
      getCampaign();
    }
  }, []);

  const onSubmit = async (data) => {
    try {
      const resp = await setTermClauses(data);
      registrationDispatch({
        type: 'set_campaign_request',
        campaignRequest: resp,
      });
    } catch (e) {
      console.log('e: ', e);
    }
  };

  const disableAgree = (i) => {
    if (i === 0) {
      return false;
    }
    const prevOpt = clauseOptions[i - 1];
    if (prevOpt.agree) {
      return false;
    }
    return true;
  };

  const handleNext = async () => {
    try {
      setSaving(true);
      const term_clause_ids = clauseOptions.map((x) => x.id);
      const resp = await setTermClauses({ term_clause_ids });
      registrationDispatch({
        type: 'set_application',
        application: resp,
      });

      const isOther = otherTypeCodes.includes(
        campaignRequest.campaign_is_for?.code
      );
      if (isOther) {
        history.push('/get-started/continue');
      } else {
        history.push('/get-started/agreements');
      }
    } catch (e) {
      setSaving(false);
      console.log('e: ', e);
    }
  };

  const length = clauseOptions.length;

  const handleCheck = (i) => {
    let newOpts = [...clauseOptions];
    newOpts[i]['agree'] = !newOpts[i]['agree'];
    setClauseOptions(newOpts);

    const nextIndex = clauseIndex + 1;
    if (nextIndex !== length) {
      setClauseIndex(clauseIndex + 1);
    }
  };

  if (loading) {
    return <Loading />;
  }

  const disableNext = clauseOptions.filter((x) => !x.agree).length > 0;
  const clause = clauseOptions[clauseIndex];

  return (
    <Container>
      <ProgressBar selectedStep='terms-of-service' />

      <Form>
        <Row className='justify-content-center py-5'>
          <Col md='8'>
            <div className='text-center'>
              <h3>Terms of Service</h3>
              <p>
                We maintain “Our Advantage” and status as a trusted 501(c)(3)
                nonprofit because we adhere to federal and state guidelines for
                charitable fundraising. Here’s what you, your fundraising
                volunteers, and campaign supporters need to know about
                fundraising for Help Hope Live to enjoy these benefits.
              </p>
            </div>

            <Card
              className='box-shadow my-5'
              style={{
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            >
              <CardBody>
                <FormGroup check className='mb-3'>
                  <FormGroup key={clauseIndex}>
                    <h2>{clauseIndex + 1}</h2>
                    <Label>{clause?.category}</Label>
                    {clause ? parse(clause.template) : null}
                    <Label check>
                      <Input
                        id={`clause-${clauseIndex}`}
                        type='checkbox'
                        onChange={() => handleCheck(clauseIndex)}
                        name={`clause-${clauseIndex}`}
                      />
                      {`I accept`}
                    </Label>
                  </FormGroup>
                </FormGroup>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {clauseIndex + 1 === length && (
          <div className='text-center mb-5'>
            <Button
              color='primary'
              onClick={handleNext}
              disabled={saving || disableNext}
            >
              {saving ? `Saving...` : `Next`}
            </Button>
          </div>
        )}
      </Form>
    </Container>
  );
};
